import PropTypes from 'prop-types';
import React from 'react';
import './StripeEmptyState.css';

const StripeEmptyState = ({
  icon,
  title,
  description,
  action,
  className = '',
  size = 'md',
  ...props
}) => {
  return (
    <div className={`stripe-empty-state stripe-empty-state-${size} ${className}`} {...props}>
      {icon && <div className="stripe-empty-state-icon">{icon}</div>}
      {title && <h3 className="stripe-empty-state-title">{title}</h3>}
      {description && <p className="stripe-empty-state-description">{description}</p>}
      {action && <div className="stripe-empty-state-action">{action}</div>}
    </div>
  );
};

StripeEmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  action: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

export default StripeEmptyState;

